import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import React from "react";
import ProductUnitOfMeasure from "@WhiteCap/Components/ProductUnitOfMeasure";
import { css } from "styled-components";

const GuestUOM = () => {
    return (
        <ProductUnitOfMeasure
            showLabel={true}
            labelOverride={{
                css: css`
                    margin-right: 2px;
                `,
            }}
            valueOverride={{
                css: css`
                    font-weight: bold;
                `,
            }}
        />
    );
};

// Widget definition for the form
const widgetModule: WidgetModule = {
    component: GuestUOM,
    definition: {
        displayName: "Guest UOM",
        group: "Common",
    },
};

export default widgetModule;

{
    /* EC-235 : SubTask - EC-527 = Wizard Structure of the form (Level 1) i.e Customer Basic Info */
}
